var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-content"},[_c('img',{attrs:{"src":require("@/assets/empty.svg"),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []

export { render, staticRenderFns }